import { render } from "./RecentChangedTopics.vue?vue&type=template&id=aa947ef4&scoped=true"
import script from "./RecentChangedTopics.vue?vue&type=script&lang=js"
export * from "./RecentChangedTopics.vue?vue&type=script&lang=js"

import "./RecentChangedTopics.vue?vue&type=style&index=0&id=aa947ef4&scoped=true&lang=css"
import "./RecentChangedTopics.vue?vue&type=style&index=1&id=aa947ef4&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa947ef4"]])

export default __exports__